import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const StyledCreatorLink = styled.div`
	display: flex;
	overflow: hidden;
	max-width: 100%;
	gap: var(--gap-m);

	& > *:last-child {
		min-width: 0;
		flex-basis: 0;
		flex-grow: 1;
	}
`;

export const nickStyle = css`
	display: block;
	overflow: hidden;
	width: 100%;
	max-width: 100%;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
